import { ITranslationMap } from '@principle-theorem/practice-migrations/interfaces';
import { type ITag } from '@principle-theorem/principle-core/interfaces';
import {
  isSameRef,
  type AtLeast,
  type IXSLXExport,
  type WithRef,
  type XSLXCell,
} from '@principle-theorem/shared';
import type { Column } from 'exceljs';
import { sortBy } from 'lodash';

export interface IAppointmentTagXSLX {
  tag: string;
  mapTo: string;
}

export const APPOINTMENT_TAG_HEADERS: AtLeast<Column, 'key' | 'header'>[] = [
  {
    key: 'tag',
    header: 'Tag',
    width: 30,
  },
  {
    key: 'mapTo',
    header: 'Map To',
    width: 30,
  },
];

export class AppointmentTagsToXSLX
  implements IXSLXExport<string, IAppointmentTagXSLX>
{
  headers = APPOINTMENT_TAG_HEADERS;

  constructor(
    private _appointmentTags: WithRef<ITag>[],
    private _existingMappings: ITranslationMap<ITag>[]
  ) {}

  translate(
    sourceTags: string[]
  ): Record<keyof IAppointmentTagXSLX, XSLXCell>[] {
    const tagOptions = sortBy(this._appointmentTags, 'name').map(
      (tag) => tag.name
    );
    return sourceTags.map((sourceTag) => {
      const existingRecord = this._existingMappings.find(
        (existingMapping) => existingMapping.sourceIdentifier === sourceTag
      );

      const associatedValue = existingRecord?.destinationIdentifier;
      const mappedTag = associatedValue
        ? this._appointmentTags.find((tag) => isSameRef(tag, associatedValue))
            ?.name
        : undefined;

      return {
        tag: {
          value: sourceTag,
        },
        mapTo: {
          value: mappedTag,
          dataValidation: {
            type: 'list',
            formulae: [`"${tagOptions.join(',')}"`],
          },
        },
      };
    });
  }
}
